/** Список шагов маршрута. */

import type { Plan, StopAlert } from '@cdf/shared';

import { StopCard, type StopCardState } from './StopCard';

interface StopListProps {
  plan: Plan;
  done: ReadonlySet<number>;
  skipped: ReadonlySet<number>;
  currentIndex: number | null;
  alerts: ReadonlyMap<number, StopAlert>;
  flashIndex: number | null;
  busyIndex: number | null;
  /** Порог литров из настроек — карточки считают от него запас. */
  minLitersForBonus: number;
  onDone(index: number): void;
  onSkip(index: number): void;
  onShowOnMap(index: number): void;
}

export function StopList({
  plan,
  done,
  skipped,
  currentIndex,
  alerts,
  flashIndex,
  busyIndex,
  minLitersForBonus,
  onDone,
  onSkip,
  onShowOnMap,
}: StopListProps): JSX.Element {
  return (
    <ol className="stops" aria-label="Шаги маршрута">
      {plan.stops.map((stop) => {
        const state: StopCardState = done.has(stop.index)
          ? 'done'
          : skipped.has(stop.index)
            ? 'skipped'
            : stop.index === currentIndex
              ? 'current'
              : 'pending';

        return (
          <StopCard
            key={`${stop.index}-${stop.car.id}`}
            stop={stop}
            state={state}
            alert={alerts.get(stop.index) ?? stop.alert}
            flash={flashIndex === stop.index}
            busy={busyIndex === stop.index}
            minLitersForBonus={minLitersForBonus}
            onDone={() => onDone(stop.index)}
            onSkip={() => onSkip(stop.index)}
            onShowOnMap={() => onShowOnMap(stop.index)}
          />
        );
      })}
    </ol>
  );
}
